/**
 * 账单数据源筛选的默认值常量
 * 页面组件和筛选组件共享此常量，确保一致性
 */
import { IDS_DEFAULT_FILTER_STATUSES } from "../../constants";

export const DEFAULT_FILTER_VALUES = {
    // 表单使用的数组格式（Select 多选组件使用数组）
    form: {
        status: IDS_DEFAULT_FILTER_STATUSES,
        source_type: ["INVOICE_UPLOAD", "UPLOAD", "AGENT_UPLOAD"],
    },
    // API 使用的逗号分隔字符串格式
    api: {
        status: IDS_DEFAULT_FILTER_STATUSES.join(","),
        source_type: "INVOICE_UPLOAD,UPLOAD,AGENT_UPLOAD",
    },
};

/**
 * 将表单值转换为 API 参数格式
 * 
 * 转换规则：
 * - 数组字段（status, source_type, supplier_id, cost_type）转换为逗号分隔字符串
 * - 日期范围转换为 created_at_start 和 created_at_end（YYYY-MM-DD 格式）
 * - file_path 重命名为 search
 * - has_file_group 直接透传
 * 
 * @param {Object} formValues - 表单原始值
 * @returns {Object} - API 参数对象
 */
export const transformFormToApiParams = (formValues) => {
    const params = {};

    // 处理状态筛选 - 数组转逗号分隔字符串
    if (formValues.status && Array.isArray(formValues.status) && formValues.status.length > 0) {
        params.status = formValues.status.join(",");
    }

    // 处理来源类型 - 数组转逗号分隔字符串
    if (formValues.source_type && Array.isArray(formValues.source_type) && formValues.source_type.length > 0) {
        params.source_type = formValues.source_type.join(",");
    }

    // 处理供应商ID - 数组转逗号分隔字符串
    if (formValues.supplier_id && Array.isArray(formValues.supplier_id) && formValues.supplier_id.length > 0) {
        params.supplier_id = formValues.supplier_id.join(",");
    }

    // 处理费用类型 - 数组转逗号分隔字符串
    if (formValues.cost_type && Array.isArray(formValues.cost_type) && formValues.cost_type.length > 0) {
        params.cost_type = formValues.cost_type.join(",");
    }

    // 处理日期范围 - 转换为后端期望的 created_at_start 和 created_at_end
    if (formValues.date_range && formValues.date_range.length === 2) {
        if (formValues.date_range[0]) {
            params.created_at_start = formValues.date_range[0].format("YYYY-MM-DD");
        }
        if (formValues.date_range[1]) {
            params.created_at_end = formValues.date_range[1].format("YYYY-MM-DD");
        }
    }

    // 处理文件名关键词 - 后端接口使用 search 参数
    if (formValues.file_path && formValues.file_path.trim()) {
        params.search = formValues.file_path.trim();
    }

    // 处理关联组筛选
    if (formValues.has_file_group !== undefined && formValues.has_file_group !== null) {
        params.has_file_group = formValues.has_file_group;
    }

    // 处理批次号筛选（V4.7 新增）
    if (formValues.batch_number && formValues.batch_number.trim()) {
        params.batch_number = formValues.batch_number.trim();
    }

    // 处理机场代码筛选（V4.8 新增）- 数组转逗号分隔字符串
    if (formValues.airport_code && Array.isArray(formValues.airport_code) && formValues.airport_code.length > 0) {
        params.airport_code = formValues.airport_code.join(",");
    } else if (typeof formValues.airport_code === "string" && formValues.airport_code.trim()) {
        params.airport_code = formValues.airport_code.trim();
    }

    // 处理结构化数据搜索
    if (formValues.structured_data_search && formValues.structured_data_search.trim()) {
        params.structured_data_search = formValues.structured_data_search.trim();
    }

    // 处理创建人筛选（V4.5 新增）- 直接透传用户ID
    if (formValues.created_by_user_id !== undefined && formValues.created_by_user_id !== null) {
        params.created_by_user_id = formValues.created_by_user_id;
    }

    return params;
};
